import { getItemDisplayString } from "features/configuration/GeneralConfiguration/utils";
import { useContext, useEffect, useState } from "react";
import Styles from "features/configuration/GeneralConfiguration/ConfigurationItem/styles.tsx";
import {
  ConfigurationItem,
  useConfigurationItem,
} from "features/configuration/GeneralConfiguration/ConfigurationItem";
import {
  GeneralConfigurationContext,
  ModalItemContext,
} from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import ConfigurationItemRow from "features/configuration/GeneralConfiguration/ConfigurationItem/ConfigurationItemRow";

const CombinedItem = ({ item, ...props }) => {
  const {
    itemName,
    itemChildren,
    itemShouldDisplay,
    overrideComponent,
    itemValueModified,
  } = useConfigurationItem({ item });
  const { idToItem, editable } = useContext(GeneralConfigurationContext);
  const { inModal } = useContext(ModalItemContext);
  const [expanded, setExpanded] = useState(false);
  const display = getItemDisplayString(item, idToItem);

  useEffect(() => {
    if (!itemShouldDisplay) {
      setExpanded(false);
    }
  }, [itemShouldDisplay]);

  const extraInfoComponent = itemShouldDisplay ? (
    <span style={{ paddingRight: props.extraInfoAlignRight ? 0 : 10 }}>
      {display}
    </span>
  ) : null;
  const overridePlaceholder = inModal ? null : <span />;

  return (
    <>
      <ConfigurationItemRow
        nameComponent={itemName}
        extraInfoComponent={extraInfoComponent}
        overrideComponent={overrideComponent || overridePlaceholder}
        onClickRow={() => setExpanded(!expanded)}
        inactive={itemShouldDisplay === false}
        showPointer={true}
        itemValueModified={itemValueModified}
        extraInfoAlignRight={inModal}
      />
      {editable && itemChildren.length === 2 && (
        <Styles.CombinedItemInnerWrapper $expanded={expanded}>
          <div style={{ marginRight: 20 }}>
            <ConfigurationItem
              item={itemChildren[0]}
              inCombinedItem={true}
              {...props}
            />
          </div>
          <ConfigurationItem
            item={itemChildren[1]}
            inCombinedItem={true}
            {...props}
          />
        </Styles.CombinedItemInnerWrapper>
      )}
    </>
  );
};

export default CombinedItem;
